
  import { Component, Prop } from "vue-property-decorator";
  import { mixins } from "vue-class-component";

  import TabsUnderline from "@/components/tabs/TabsUnderlineV2.vue";
  import RouteTabs from "@/entities/RouteTabs";

  import GetRelativeRouteNameMixin from "@/mixins/route/GetRelativeRouteNameMixin.vue";

  import RouteNames from "@/entities/RouteNames";

  @Component({
    components: {
      TabsUnderline,
    },
  })
  export default class TabsWithRoutes extends mixins(GetRelativeRouteNameMixin) {
    @Prop({ type: Object, required: true }) readonly routeTabs!: RouteTabs;
     @Prop({ type: String }) readonly navClass!: string;
     @Prop({ type: String }) readonly listClass!: string;
     @Prop({ type: String }) readonly variant!: string;

    get tabs(): (string | undefined)[] {
      return Object.values(this.routeTabs);
    }

    get routeNames(): string[] {
      return Object.keys(this.routeTabs);
    }

    get tabIndex(): number {
      const routeName = this.$route.name as RouteNames;
      const prefixedRouteName = this.getRelativeRouteName(routeName) as RouteNames;

      let tabIndex = 0;
      const routeNameIndex = this.findTabIndex(routeName);
      const prefixedRouteNameIndex = this.findTabIndex(prefixedRouteName);

      if (routeNameIndex !== -1) {
        tabIndex = routeNameIndex;
      }

      if (prefixedRouteNameIndex !== -1) {
        tabIndex = prefixedRouteNameIndex;
      }

      return tabIndex;
    }

    findTabIndex(routeName: RouteNames): number {
      return this.tabs.findIndex((tab) => tab === this.routeTabs[routeName]);
    }

    setRoute(tabIndex: number): void {
      if (tabIndex === this.tabIndex) {
        return;
      }

      this.$router.push({ name: this.routeNames[tabIndex] });
      this.$emit('tabChanged');
    }
  }
